import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap';

class Input extends React.Component {
  getValue() {
    return this.input.value;
  }

  renderLabel() {
    if (!this.props.label) {
      return null;
    }
    return (
      <ControlLabel className={this.props.labelClassName}>
        {this.props.label}
      </ControlLabel>
    );
  }

  renderControl() {
    if (this.props.type === 'textarea') {
      return (
        <FormControl
          disabled={this.props.disabled}
          componentClass="textarea"
          placeholder={this.props.placeholder}
          inputRef={(ref) => { this.input = ref; }}
          defaultValue={this.props.defaultValue}
          rows={this.props.rows}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
        />
      );
    }
    if (this.props.type === 'checkbox') {
      return (
        <Checkbox
          disabled={this.props.disabled}
          checked={this.props.checked}
          type={this.props.type}
          inputRef={(ref) => { this.input = ref; }}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
        />
      );
    }
    if (this.props.type === 'select') {
      return (
        <FormControl
          disabled={this.props.disabled}
          componentClass="select"
          inputRef={(ref) => { this.input = ref; }}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          multiple={this.props.multiple}
        >
          {this.props.option}
        </FormControl>
      );
    }
    return (
      <FormControl
        disabled={this.props.disabled}
        type={this.props.type}
        placeholder={this.props.placeholder}
        inputRef={(ref) => { this.input = ref; }}
        defaultValue={this.props.defaultValue}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}
        id={this.props.id}
      />
    );
  }

  render() {
    if (this.props.noFormGroup) {
      return (
        <div className={this.props.wrapperClassName}>
          {this.renderLabel()}
          {this.renderControl()}
        </div>
      );
    }
    return (
      <FormGroup className={this.props.wrapperClassName}>
        {this.renderLabel()}
        {this.renderControl()}
      </FormGroup>
    );
  }
}

Input.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  rows: PropTypes.number,
  multiple: PropTypes.bool,
  option: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  noFormGroup: PropTypes.bool,
  placeholder: PropTypes.string,
};

Input.defaultProps = {
  label: null,
  labelClassName: null,
  wrapperClassName: null,
  defaultValue: null,
  rows: null,
  onChange: null,
  onBlur: null,
  multiple: null,
  option: null,
  checked: false,
  disabled: false,
  noFormGroup: false,
  placeholder: '',
};

export default Input;
